(function(angular, schoolwork12) {
    'use strict';

    angular.module(schoolwork12.app.auth.name)
    .controller(schoolwork12.app.auth.controllers.keycodeLogin,
                ['$scope', '$location', 'storage', schoolwork12.app.auth.services.authentication, schoolwork12.app.common.services.eventNotification,
                            function($scope, $location, storage, authentication, eventNotification)
                            {
                                console.info('calling keycodeLogin Controller:......');
                                console.info('keycode query param: '.concat($location.search().keycode));

                                 /**
                                   todo: store this newly validated keycode in local storage
                                   todo: handle edge cases
                                    (1) call keycodeLogin with keycode == null
                                    if (authenticatedUser is in memory)
                                      route to student search
                                    if (authenticatedUser found in localStorage)
                                        call isValidSession API to validation this local storage keycode
                                          if (valid)
                                                route to student Search page
                                            if (not valid)
                                                route to UnAuthorized Page
                                        else
                                            route to Error page
                                   **/
                                const keycode = sessionStorage.getItem('keycode');
                                sessionStorage.removeItem('keycode');
                                authentication.keycodeAuthenticate(keycode).then(
                                        function(data) {
                                            if (data) {
                                               storage.setData('X-API-TOKEN', angular.toJson(data));
                                               // Student
                                               if(angular.isDefined(data.studentId) || authentication.hasLCRole()) {
                                            	   console.info('User is a student. send to: '.concat(schoolwork12.app.studentview.routes.studentViewGradPlan));
                                            	   $location.url(schoolwork12.app.studentview.routes.studentViewGradPlan);
                                               } else {
                                            	   console.info('User is NOT a student.');
                                            	   $location.url(schoolwork12.app.student.routes.studentSearch);
                                               }

                                            }
                                        }, function(error) {
                                                console.info('Failed to keycodeLogin: '.concat(angular.toJson(error)));
                                                if(angular.isDefined($location.search().errorPageFailureRedirect) && $location.search().errorPageFailureRedirect=='1') {
                                                	console.info('errorPageFailureRedirect is set. Send to LoginError');
                                                	eventNotification.broadcast(schoolwork12.app.auth.events.userLoginError, authentication.getCurrentUser());
                                                	$location.url(schoolwork12.app.auth.routes.loginError);
                                                } else {
                                                	console.info('errorPageFailureRedirect is NOT set. Send to Login');
                                                	$location.url(schoolwork12.app.auth.routes.login);
                                                }

                                        }
                                );
                            }
                ]
               );

}(angular, schoolwork12));
